<template>
  <div>
    <b-modal id="modalEditFirewallRulesSetting" ref="modalEditFirewallRulesSetting" :title="$t('Firewall rules')" hide-footer size="lg" @shown="shown">
      <div v-if="editItem">
        <b-tabs vertical pills card>
          <b-tab :title="$t('Execute when')">
            <b-form-group label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-select v-model="curFwSubst" :options="fwSubst"/>
                <b-input-group-append>
                  <md-button @click="addRules" class="md-raised" style="margin-top:0rem">{{ $t('Insert') }}</md-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Firewall rules')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.text" aria-describedby="inputFeedbackName" :state="editItem.text.length > 0 && editItem.text.length < 1024"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                {{ $t('Enter value (length must be between 1 and 1023)') }}
              </b-form-invalid-feedback>
              <b-form-checkbox v-if="editItem.affector_type === 2" v-model="editItem.isUrlParam">{{ $t('URL parameters') }}</b-form-checkbox>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Event')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-select v-model="editItem.curEvent" :options="event"/>
                <b-input-group-append>
                  <md-button @click="addEvent" class="md-raised" style="margin-top:0rem">{{ $t('Add') }}</md-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-table striped hover small
              :items="eventItems"
              :fields="eventFields">
              <template v-slot:cell(actions)="row">
                <i @click.stop="ClickOnDeleteButton(row)" class="danger fa fa-trash-alt fa-lg"/>
              </template>
            </b-table>
          </b-tab>
          <b-tab :title="$t('Execute for')">
            <b-form-group label-align="right" :label="$t('All users')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox switch size="lg" v-model="editItem.allUsers"/>
            </b-form-group>
            <b-form-group label-align="right" :disabled="editItem.allUsers" :label="$t('User ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem.user_id"/>
            </b-form-group>
            <b-form-group label-align="right" :disabled="editItem.allUsers" :label="$t('Group name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="editItem.group_id" :options="groups"/>
            </b-form-group>
            <b-form-group label-align="right" :disabled="editItem.allUsers" :label="$t('Tariff name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="editItem.tariff_id" :options="tariffs"/>
            </b-form-group>
            <b-form-group label-align="right" :disabled="editItem.allUsers" :label="$t('All parameters match')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox switch size="lg" v-model="editItem.allParam"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Firewall')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="editItem.affector_id" :options="firewall"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select @change="affectorTypeChanged" v-model="editItem.affector_type" :options="affectorTypes"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Details')">
            <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.comment" />
            </b-form-group>
          </b-tab>
        </b-tabs>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditFirewallRulesSetting')" size="lg"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      urlParamMarker: 'THERE_ARE_URL_PARAMS!',
      curFwSubst: 1,
      eventItems: [],
      deleteImage: require('@/assets/img/document_delete.png'),
      eventFields: [
        {key: 'text', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      affectorTypes: [
        {value: 0, text: this.$i18n.t('NetUP')},
        {value: 1, text: this.$i18n.t('RabbitMQ')},
        {value: 2, text: this.$i18n.t('HTTP')}
      ],
      event: [
        {value: 1, text: this.$i18n.t('Internet "On"')},
        {value: 2, text: this.$i18n.t('Internet "Off"')},
        {value: 4, text: this.$i18n.t('Dialup link added')},
        {value: 8, text: this.$i18n.t('Dialup link modified')},
        {value: 16, text: this.$i18n.t('Dialup link deleted')},
        {value: 32, text: this.$i18n.t('Block type changed')},
        {value: 64, text: this.$i18n.t('User added')},
        {value: 128, text: this.$i18n.t('User modified')},
        {value: 256, text: this.$i18n.t('User deleted')},
        {value: 512, text: this.$i18n.t('Tech parameter added')},
        {value: 1024, text: this.$i18n.t('Tech parameter modified')},
        {value: 2048, text: this.$i18n.t('Tech parameter deleted')},
        {value: 4096, text: this.$i18n.t('IP traffic link added')},
        {value: 8192, text: this.$i18n.t('IP traffic link modified')},
        {value: 16384, text: this.$i18n.t('IP traffic link deleted')},
        {value: 32768, text: this.$i18n.t('Raw traffic file closed')},
        {value: 65536, text: this.$i18n.t('Log file closed')},
        {value: 131072, text: this.$i18n.t('Hotspot enabled')},
        {value: 262144, text: this.$i18n.t('Hotspot disabled')},
        {value: 524288, text: this.$i18n.t('Session opened')},
        {value: 1048576, text: this.$i18n.t('Session closed')},
        {value: 2097152, text: this.$i18n.t('Set bandwidth limit (incoming)')},
        {value: 4194304, text: this.$i18n.t('Edit bandwidth limit (incoming)')},
        {value: 8388608, text: this.$i18n.t('Delete bandwidth limit (incoming)')},
        {value: 16777216, text: this.$i18n.t('Set bandwidth limit (outgoing)')},
        {value: 33554432, text: this.$i18n.t('Edit bandwidth limit (outgoing)')},
        {value: 67108864, text: this.$i18n.t('Delete bandwidth limit (outgoing)')},
        {value: 134217728, text: this.$i18n.t('Telephone service link added')},
        {value: 268435456, text: this.$i18n.t('Telephone service link modified')},
        {value: 536870912, text: this.$i18n.t('Telephone service link deleted')},
        {value: 1073741824, text: this.$i18n.t('Balance notification sent')},
        {value: 2147483648, text: this.$i18n.t('New payment for account')},
        {value: 4294967296, text: this.$i18n.t('New DHCP lease')},
        {value: 8589934592, text: this.$i18n.t('DHCP lease update')},
        {value: 17179869184, text: this.$i18n.t('DHCP lease expire')},
        {value: 34359738368, text: this.$i18n.t('IPTV link added')},
        {value: 68719476736, text: this.$i18n.t('IPTV link modified')},
        {value: 137438953472, text: this.$i18n.t('IPTV link deleted')},
        {value: 274877906944, text: this.$i18n.t('Add HotSpot user')},
        {value: 549755813888, text: this.$i18n.t('VOD link added')},
        {value: 1099511627776, text: this.$i18n.t('VOD link modified')},
        {value: 2199023255552, text: this.$i18n.t('VOD link deleted')},
        {value: 4398046511104, text: this.$i18n.t('Record to User change log report')},
        {value: 8796093022208, text: this.$i18n.t('Once link added')},
        {value: 17592186044416, text: this.$i18n.t('Once link modified')},
        {value: 35184372088832, text: this.$i18n.t('Once link deleted')}

      ]
    }
  },
  methods: {
    affectorTypeChanged () {
      this.editItem.affector_id = 0
    },
    save () {
      if (!this.editItem.text) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Firewall rules fields is invalid'), 'Error')
        return
      }
      if (!this.eventItems.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Event table is empty'), 'Error')
        return
      }
      if (this.editItem.affector_type === null) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Choose affector type'), 'Error')
        return
      }
      if (this.editItem.text.length === 0 || this.editItem.text.length > 1023) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Length of firewall rule must be between 1 and 1023'), 'Error')
        return
      }

      if (this.editItem.isUrlParam) {
        this.editItem.text = this.urlParamMarker + this.editItem.text
      }
      delete this.editItem['isUrlParam']

      if (this.editItem.allUsers) {
        this.editItem.user_id = 0
        this.editItem.group_id = 0
        this.editItem.tariff_id = 0
        this.editItem.flags = 1
      } else {
        this.editItem.user_id = Number(this.editItem.user_id)
        if (this.editItem.allParam) {
          this.editItem.flags = 2
        } else {
          this.editItem.flags = 0
        }
      }
      this.editItem.events = 0
      for (let el of this.eventItems) {
        this.editItem.events += el.value
      }
      let response = this.editItem.rule_id !== 0
        ? this.$store.dispatch('Settings/UPDATE_FIREWALL_RULES', this.editItem)
        : this.$store.dispatch('Settings/CREATE_FIREWALL_RULES', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_FIREWALL_RULES')
          this.$refs.modalEditFirewallRulesSetting.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    ClickOnDeleteButton (row) {
      this.eventItems = this.eventItems.filter((value) => {
        return value !== row.item
      })
      this.curFwSubst = 1
    },
    addEvent () {
      for (let el of this.eventItems) {
        if (this.editItem.curEvent === el.value) {
          return
        }
      }
      for (let el of this.event) {
        if (this.editItem.curEvent === el.value) {
          this.eventItems.push(el)
          break
        }
      }
    },
    shown () {
      this.eventItems = []
      // long numbers in chrome don't work with logical operations
      if (this.editItem.events) {
        let tmp = JSON.parse(JSON.stringify(this.editItem.events))
        for (let i = this.event.length - 1; i >= 0; --i) {
          let el = this.event[i]
          if (tmp & el.value) {
            this.eventItems.push(JSON.parse(JSON.stringify(el)))
            tmp = tmp - el.value
            continue
          }
          if (el.value > 2147483648) {
            if ((tmp - el.value) >= 0) {
              tmp = tmp - el.value
              this.eventItems.push(JSON.parse(JSON.stringify(el)))
            }
          }
        }
      }
    },
    addRules () {
      for (let el of this.fwSubst) {
        if (el.value === this.curFwSubst) {
          this.editItem.text = this.editItem.text + el.text
        }
      }
    }
  },
  computed: {
    allFWSubst () {
      return this.$store.getters['Settings/FW_SUBST']
    },
    fwSubst () {
      var bigInt = require('big-integer')
      let fwSubst = []
      let num = 0
      for (let elEvents of this.eventItems) {
        for (let el of this.allFWSubst) {
          let res = bigInt(elEvents.value).and(el.events)
          if (res > 0) {
            let newEl = {
              value: 0,
              text: ''
            }
            newEl.value = ++num
            newEl.text = el.subst_info
            fwSubst.push(newEl)
          }
        }
      }
      return fwSubst
    },
    firewall () {
      if (this.editItem.affector_type === 1) {
        return this.rabbitMQServers
      } else if (this.editItem.affector_type === 2) {
        return this.httpServers
      } else {
        return this.oldFirewall
      }
    },
    oldFirewall () {
      let res = []
      for (let el of this.$store.getters['Settings/FIREWALLS']) {
        let newEl = {}
        newEl.value = el.id
        newEl.text = el.name
        res.push(newEl)
      }
      let newEl = {
        value: 0,
        text: this.$t('Any')
      }
      res.push(newEl)
      return res
    },
    tariffs () {
      let res = []
      for (let el of this.$store.getters['Tariffing/TARIFFS']) {
        let newEl = {}
        newEl.value = el.id
        newEl.text = el.name + ' (' + el.id + ')'
        res.push(newEl)
      }
      let newEl = {
        value: 0,
        text: this.$t('Any (0)')
      }
      res.push(newEl)
      return res
    },
    groups () {
      let res = []
      for (let el of this.$store.getters['Users/GROUPS']) {
        let newEl = {}
        newEl.value = el.group_id
        newEl.text = el.group_name + ' (' + el.group_id + ')'
        res.push(newEl)
      }
      let newEl = {
        value: 0,
        text: this.$t('Any (0)')
      }
      res.push(newEl)
      return res
    },
    rabbitMQServers () {
      let res = []
      for (let el of this.$store.getters['Settings/RABBIT_MQ_SERVERS']) {
        let newEl = {}
        newEl.value = el.id
        newEl.text = el.name
        res.push(newEl)
      }
      let newEl = {
        value: 0,
        text: this.$t('Any')
      }
      res.push(newEl)
      return res
    },
    httpServers () {
      let res = []
      for (let el of this.$store.getters['Settings/HTTP_SERVERS']) {
        let newEl = {}
        newEl.value = el.id
        newEl.text = el.name
        res.push(newEl)
      }
      let newEl = {
        value: 0,
        text: this.$t('Any')
      }
      res.push(newEl)
      return res
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_RABBIT_MQ_SERVERS')
    this.$store.dispatch('Settings/GET_HTTP_SERVERS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/firewallRules/editModal.vue